module.exports = __webpack_public_path__ + "static/pineWreath_389-b2bcd46635ba4ddafd4e4cfc4334c115.png";